import React from 'react';
import config from '../config/config';

const PRINT_CONFIG_MESSAGES = config.print.messages;

/**
 * 印刷ポップアップコンポーネント
 */
const PrintPopup = ({
  isPrintPopupOpen,
  onClosePrintPopup,
  onNormalPrint,
  onSuperPrint,
}) => {
  if (!isPrintPopupOpen) {
    return null;
  }

  // オーバーレイ（グレー背景）上を押した時だけ閉じる
  // モーダル本体を押した場合は閉じない（targetがモーダル本体、currentTargetがオーバーレイ）
  const handleOverlayPointerDown = (e) => {
    const clickedOverlayItself = (e.target === e.currentTarget);
    if (!clickedOverlayItself) {
      return;
    }
    onClosePrintPopup();
  };

  return (
    <div
      className="print-modal-overlay"
      onPointerDown={handleOverlayPointerDown}
    >
      <div className="print-modal-clean">
        <h3>{PRINT_CONFIG_MESSAGES.title}</h3>
        <p>{PRINT_CONFIG_MESSAGES.description}</p>

        <div className="button-container">
          {/* 通常印刷ボタン */}
          <button
            onClick={() => {
              onNormalPrint();
              onClosePrintPopup();
            }}
            className="normal-print-btn"
          >
            <span className="btn-icon">📸</span>
            <div className="btn-text">
              <div className="btn-title">{PRINT_CONFIG_MESSAGES.normalTitle}</div>
              <div className="btn-desc">{PRINT_CONFIG_MESSAGES.normalDesc}</div>
            </div>
          </button>

          {/* 超印刷ボタン */}
          <button
            onClick={() => {
              onSuperPrint();
              onClosePrintPopup();
            }}
            className="super-print-btn"
          >
            <span className="btn-icon">⚡</span>
            <div className="btn-text">
              <div className="btn-title">{PRINT_CONFIG_MESSAGES.superTitle}</div>
              <div className="btn-desc">{PRINT_CONFIG_MESSAGES.superDesc}</div>
            </div>
          </button>
        </div>

        <div className="print-modal-footer">
          {/* キャンセルボタン */}
          <button onClick={onClosePrintPopup} className="cancel-btn">
            {PRINT_CONFIG_MESSAGES.cancel}
          </button>
          <div className="hint-text">
            {PRINT_CONFIG_MESSAGES.hint}
          </div>
        </div>

      </div>

    </div>
  );
};

export default PrintPopup;
